import React, {Component} from "react";
import {request} from "../../../api-client";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid} from "@material-ui/core";
import localization from "../../../config/localization";
import "../../../layouts/Home/HomeElements/AddToPlaylistDialog.css";
import GlobalSnackbar, {GlobalSnackbarTypes} from "../../../components/Letflow/Snackbar/GlobalSnackbar";
import PlaylistImage from "../../../assets/img/Letflow/playlist.jpg";

class AddToGlobalPlaylistDialog extends Component {
  state = {
    playlists: [],
    requested: false,
    fetching: true
  };

  requestPlaylists = () =>
    request.playlist
      .getAllGlobal()
      .then(playlists => {
        this.setState({
          playlists: playlists.data.filter(playlist => playlist.tags.length === 0),
          fetching: false
        });
      })

  handleAddToPlaylist = (playlistId, data) => {
    data.musicIds.push(this.props.selectedTrack)
    return request.playlist
      .updateGlobal( playlistId, data )
      .then(() => {
        this.setState({ addingPlaylistSuccess: true });
        GlobalSnackbar.show({ message: localization.get("playlist.add"), type: GlobalSnackbarTypes.SUCCESS });
      })}

  handlePlaylistClicked = (playlist) => {
    const data = {musicIds: playlist.musics}
    this.handleAddToPlaylist(playlist.id, data)
      .then(() => this.props.handleClose('success'))
    }


  //----------------Bodies-------------------------

  renderPlaylistSelection = () => {
    return (
      this.state.playlists.length > 0 ? (
        <div style={{ margin: "30px" }}>
          <Grid spacing={16} justify="center" container>
            {this.state.playlists.map(playlist => (
              <Grid item>
                <div
                  className={'add-to-playlist-dialog-playlist'}
                  style={{ cursor: "pointer", overflow: "hidden", position: "relative" }}
                  onClick={() => this.handlePlaylistClicked(playlist)}
                >
                  <img
                    style={{ maxWidth: "150px" }}
                    src={
                      (playlist.created_by_admin && playlist.image) ?
                        request.file.image.makeCroppedUrl(playlist.image.id, 200, 200)
                        : playlist.featuredImage && playlist.featuredImage.image ?
                        request.file.image.makeCroppedUrl(playlist.featuredImage.image.id, 200, 200)
                        : PlaylistImage
                    }
                    alt="playlist"
                  />
                  <div
                    className="featured-image-title"
                    style={{
                      color: playlist.featuredImage ? playlist.featuredImage.color : "black",
                      fontSize: 20,
                      letterSpacing: -2,
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      padding: "0 10px",
                      position: "absolute",
                      top: 0,
                      width: "100%",
                      textAlign: "center"
                    }}
                  >
                    {playlist.title.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
        </div>
      ) : (
        <div style={{ margin: "30px" }}>{localization.get('alert.no_playlist_available')}</div>
      )
    )
  }


  //----------------Render--------------------------

  renderDialog = (title, body) => (
    <Dialog open={this.props.show} onClose={this.props.handleClose} style={{ textAlign: "center", minWidth: "350px" }}>
      <DialogTitle style={{ width: "100%" }} id="simple-dialog-title">{title}</DialogTitle>
      <DialogContent>{body}</DialogContent>
    </Dialog>
  );

  render = () => {
    let title, body = []
    if (this.props.show && !this.state.requested){
      this.requestPlaylists()
        .then(() => this.setState({requested: true}));
    }
    title = localization.get('dialog.select_playlist')

    if (!this.state.fetching) {
      body = this.renderPlaylistSelection()
    } else {
      body = <div style={{ margin: "30px" }}>{localization.get('loading')}</div>
    }

    return (
    <span>
      {this.renderDialog(title, body)}
    </span>
      )
  }

}

export default AddToGlobalPlaylistDialog;
